import { Autocomplete, FormControl, Grid, TextField } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import manS from '../../assets/manS.jpg'
import React from 'react'
import { Client } from '../../redux/reducers/clients'
import { useSelector } from '../../redux/hooks/useSelector'
import { useTranslation } from 'react-i18next'
import { DatePicker, LocalizationProvider } from '@mui/lab'
import AdapterDateFns from '@date-io/date-fns'
import { codeListCodeItems } from '../../utils/codeListToArrowSelect'
import { CLIENT_SEX, CONTRACT_TYPE } from '../../constants/codeLists'
import { CodeList } from '../../types/common'

const useStyles = makeStyles(theme => ({
  manIcon: {
    width: '100%',
  },
}))

interface Props {
  client: Client,
  codeList: CodeList[] | undefined
  onClientAttributeChange: (name: string) => (value: any) => void
  setClient: (client: Client) => void
}

export const ClientNameContainer: React.FC<Props> = ({ onClientAttributeChange, client, codeList, setClient }) => {
  const classes = useStyles()
  const errors = useSelector(state => state.useractions.errors)

  const onClientInputChangeCreator = (name: string) => (event: any) => {
    onClientAttributeChange(name)(event.target.value)
  }

  const handleDateChangeCreator = (name: string) => (date: Date | null) => {
    onClientAttributeChange(name)(date)
  }

  const { t } = useTranslation()

  return (
    <>
      <Grid item xs={6}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <img alt="" className={classes.manIcon} src={manS} />
          </Grid>
          <Grid item xs={8}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField variant="standard" fullWidth id="bornPlace" label={t('BIRTH_PLACE')} value={client.birthPlace} onChange={onClientInputChangeCreator('birthPlace')}/>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="standard"
                  fullWidth
                  required
                  id="firstName"
                  label={t('FIRST_NAME')}
                  onChange={onClientInputChangeCreator('firstName')}
                  value={client.firstName}
                  helperText={errors['firstName'] ? 'Toto pole je povinné' : ''}
                  error={errors['firstName']}    
                />
              </Grid>
              <Grid item xs={12}>
                  <FormControl fullWidth>
                    <Autocomplete
                      id="sex"
                      filterSelectedOptions
                      options={codeListCodeItems(CLIENT_SEX, codeList)}
                      value={client.sex || ''}
                      getOptionLabel={(a: string) => t(a)}
                      onChange={(event: any, value: string | null) => {
                        setClient({ ...client, sex: value })
                      }}
                      renderInput={params => (
                        <TextField {...params} variant="standard" placeholder={t('SEX')} style={{paddingTop: '16px'}} />
                      )}
                      
                    />
                  </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              variant="standard"
              fullWidth
              id="titlePre"
              label={t('TITLE_PRE')}
              onChange={onClientInputChangeCreator('titlePre')}
              value={client.titlePre}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              variant="standard"
              fullWidth
              id="titleAfter"
              label={t('TITLE_AFTER')}
              onChange={onClientInputChangeCreator('titleAfter')}
              value={client.titleAfter}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="standard"
              fullWidth
              required
              helperText={errors['surname'] ? 'Toto pole je povinné' : ''}
              error={errors['surname']}
              id="surname"
              label={t('SURNAME')}
              onChange={onClientInputChangeCreator('surname')}
              value={client.surname}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="standard"
              fullWidth
              id="salutation"
              label={t('SALUTATION')}
              onChange={onClientInputChangeCreator('salutation')}
              value={client.salutation}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
